<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="messenger-box">
        <div>
          <label for="facebook-id" class="input-label">Nhập Page ID tại đây:</label>
          <input
            id="facebook-id"
            class="input-field"
            placeholder="Nhập Page ID"
            nz-input
            [(ngModel)]="objectChoosing.staticdata.link"
            (blur)="updateStaticData()"
          />
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <div class="messenger-box">
      <div>
        <label for="facebook-id" class="input-label">Nhập Page ID tại đây:</label>
        <input
          id="facebook-id"
          class="input-field"
          placeholder="Nhập Page ID"
          nz-input
          [(ngModel)]="objectChoosing.staticdata.link"
          (blur)="updateStaticData()"
        />
      </div>
    </div>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li
        nz-submenu
        nzTitle="{{'hien_thi'| translate}}"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div *ngIf="device != 'mobile_portrait'" style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
          <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
            Ẩn hiển thị ở mobile
          </div>
          <nz-switch [(ngModel)]="objectChoosing.mobile_portrait_hidden"
            (ngModelChange)="updateHidden({'mobile_portrait_hidden': $event})"></nz-switch>
        </div>
        <div *ngIf="device != 'desktop'" style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
          <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
            Ẩn hiển thị ở desktop
          </div>
          <nz-switch [(ngModel)]="objectChoosing.desktop_hidden"
            (ngModelChange)="updateHidden({'desktop_hidden': $event})"></nz-switch>
        </div>
        <div *ngIf="device != 'tablet_landscape'" style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
          <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
            Ẩn hiển thị ở tablet landscape
          </div>
          <nz-switch [(ngModel)]="objectChoosing.tablet_landscape_hidden"
            (ngModelChange)="updateHidden({'tablet_landscape_hidden': $event})"></nz-switch>
        </div>
        <div *ngIf="device != 'tablet_portrait'" style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
          <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
            Ẩn hiển thị ở tablet portrait
          </div>
          <nz-switch [(ngModel)]="objectChoosing.tablet_portrait_hidden"
            (ngModelChange)="updateHidden({'tablet_portrait_hidden': $event})"></nz-switch>
        </div>
        <div *ngIf="device != 'mobile_landscape'" style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
          <div class="text-basic" style="display: flex; align-items: center;margin: 0; line-height: 1.5;">
            Ẩn hiển thị ở mobile landscape
          </div>
          <nz-switch [(ngModel)]="objectChoosing.mobile_landscape_hidden"
            (ngModelChange)="updateHidden({'mobile_landscape_hidden': $event})"></nz-switch>
        </div>
        </div>
      </li>
      <!-- Hình ảnh -->
      <li nz-submenu
        nzTitle="Hình ảnh"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <!-- Biểu tượng con trỏ chuột -->
        <div class="field-row mb-4">
          <nz-select [(ngModel)]="this.config['img']['type']" (ngModelChange)="updateConfig()">
            <nz-option [nzValue]="'library'" nzLabel="{{'chon_tu_thu_vien' | translate}}"></nz-option>
            <nz-option [nzValue]="'upload'" nzLabel="{{'tai_anh_len' | translate}}"></nz-option>
            <nz-option [nzValue]="'link'" [nzLabel]="'Đường dẫn ảnh'"></nz-option>
          </nz-select>
          <div class="item mt-3 mb-4">
            <!-- Trường hợp tải ảnh từ thư viện -->
            <input type="file" (change)="onUpload($event)" id="uploadMessenger" style="display: none;" />
            <button *ngIf="config['img']['type'] == 'library'" [disabled]="checkDisableUploadImage('library')"
              class="upload-background-image" [ngClass]="{ disable: checkDisableUploadImage('library') }"
              (click)="openLibrary()"><i class="bi bi-collection"></i> {{'chon_tu_thu_vien' | translate}}
            </button>
            <!-- Trường hợp tải ảnh từ máy -->
            <button *ngIf="config['img']['type'] == 'upload'" [disabled]="checkDisableUploadImage('upload')"
              class="upload-background-image" [ngClass]="{ disable: checkDisableUploadImage('upload') }"
              (click)="openUpload()"><i class="bi bi-upload"></i> {{'tai_anh_len' | translate}}
            </button>
            <!-- Trường hợp chọn ảnh từ 1 đường dẫn bất kì -->
            <textarea *ngIf="config['img']['type'] == 'link'" name="background-image"
              class="input w-100" id="background-image" placeholder="Nhập đường dẫn ảnh"
              rows="3"
              [disabled]="checkDisableUploadImage('link')"
              [(ngModel)]="config['img']['src']"
              (blur)="updateConfig()"></textarea>
          </div>
        </div>
    </li>
    </ul>
  </ng-container>
 
</div>
